import React, { memo, PropsWithChildren } from 'react';
import { Partner } from '@app/models';
import placeholderImage from 'pages/Tender/placeholder.png';
import { Info, LoadableImage, StyledOkedListBlock } from '@app/components';

interface Props {
  partner: Partner;
}

function PartnerInfo(props: Props & PropsWithChildren) {
  const { partner, children } = props;

  return (
    <div className="grid gap-4">
      <div className="bg-white rounded-lg p-4">
        <div className="flex flex-col md:flex-row">
          <div className="flex-shrink-0 w-[200px] h-[200px] md:w-[400px] md:h-[400px] mr-0 md:mr-16 mb-4 md:mb-0">
            <LoadableImage imageIds={[]} placeholder={placeholderImage} />
          </div>
          <div className="flex-1 grid gap-4 content-start">
            {!!partner.bin && <Info label="БИН партнера" value={partner.bin} />}
            {!!partner.iin && <Info label="ИИН партнера" value={partner.iin} />}
            <Info
              label="Количество договоров"
              value={partner.docsCount.toString()}
            />
            <Info label="Период сотрудничества" value="-" />
            <Info
              label="Регион"
              value={!!partner.kato ? partner.kato.nameRu : '-'}
            />
            <Info
              label="Категория"
              value={<StyledOkedListBlock list={partner.okeds} />}
            />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

export default memo(PartnerInfo);
